module.exports = __webpack_public_path__ + "0409ea3ed96fbfcac366833485626a24.png";